export default {"src":"/_next/static/media/instagram.a115a3e0.svg","height":800,"width":800};